import { EMPTY_STRING } from '../../../constants/common'
import {
  INVOICE_FIELD_NAME_NOTES,
  INVOICE_FIELD_TYPE_DATE,
  INVOICE_FIELD_TYPE_FLOAT,
  INVOICE_FIELD_TYPE_INT,
  INVOICE_FIELD_TYPE_SELECT,
  INVOICE_FIELD_TYPE_STR,
  INVOICE_FIELD_TYPE_SUPPLIER,
} from '../InvoiceModal.constants'
import { checkIsSupplierField } from '../InvoiceModal.utils'

export function getFieldComponentProps({
  disabled,
  field,
  label,
  placeholder,
}) {
  return {
    disabled,
    fieldComponentProps: { label, required: field.required },
    name: field.name,
    placeholder,
  }
}

export function getBankAccountFieldNextValue(event) {
  const nextEvent = { ...event }

  nextEvent.target.value = event.target.value
    .toUpperCase()
    .replace(/\s/g, EMPTY_STRING)

  return nextEvent
}

export function getFieldRenderType(field) {
  if (checkIsSupplierField(field)) {
    return INVOICE_FIELD_TYPE_SUPPLIER
  }

  if (field.name === INVOICE_FIELD_NAME_NOTES) {
    return INVOICE_FIELD_NAME_NOTES
  }

  switch (field.type) {
    case INVOICE_FIELD_TYPE_DATE:
      return INVOICE_FIELD_TYPE_DATE
    case INVOICE_FIELD_TYPE_SELECT:
      return INVOICE_FIELD_TYPE_SELECT
    case INVOICE_FIELD_TYPE_FLOAT:
      return INVOICE_FIELD_TYPE_FLOAT
    case INVOICE_FIELD_TYPE_INT:
      return INVOICE_FIELD_TYPE_INT
    default:
      return INVOICE_FIELD_TYPE_STR
  }
}
